<template>
  <div>
    <div class="course-banner">
      <img :src="info.infoImg" alt="">
    </div>
    <div class="course-bar">
      <a href="javascript:void(0)" :class="tabIndex==0?'active':''" @click="tab(0)">介绍</a>
      <a href="javascript:void(0)" :class="tabIndex==1?'active':''" @click="tab(1)">课程</a>
      <a href="javascript:void(0)" :class="tabIndex==2?'active':''" @click="tab(2)">课件</a>
      <a href="javascript:void(0)" :class="tabIndex==3?'active':''" @click="tab(3)">评价</a>
    </div>
    <div class="course-con" v-show="tabIndex==0">
      <div class="course-con-item">
        <h1 class="com-title">课程介绍</h1>
        <div class="txt" v-html="info.introduction"></div>
      </div>
      <div class="course-con-item">
        <h1 class="com-title">讲师介绍</h1>
        <div class="txt" v-html="info.expertIntroduction"></div>
      </div>
    </div>
    <div class="course-con" v-show="tabIndex==1">
      <ul class="chapterlist">
        <li v-for="item in chapterlist">
          <a href="https://www.pgyer.com/TZL1">{{item.name}}</a>
        </li>
      </ul>
    </div>
    <div class="course-con" v-show="tabIndex==2">
      <div class="kejian">
        <div class="txt" v-for="item in chapterlist">
          <a :href="item.fileUrl">
            <img src="/static/images/kejian.png" alt="">
          </a>
        </div>
      </div>

    </div>
    <div class="course-con" v-show="tabIndex==3">
      <ul class="commentList">
        <li v-for="item in commentlist">
          <img :src="item.userImg" alt="">
          <div class="li-rt">
            <h1><span>{{item.fullName}}</span><i>{{item.createtime}}</i></h1>
            <p v-html="item.content"></p>
          </div>
        </li>
      </ul>

    </div>
    <div class="download">
      <a href="https://www.pgyer.com/TZL1">下载APP</a>
    </div>
    <!--弹窗-->
    <div class="mask" v-show="isShow"></div>
    <div class="mask-con" v-show="isShow">
      <img class="close" @click="close" src="/static/images/close.png" alt="">
      <div class="bottom">
        <input type="text" v-model="phone" placeholder="请输入手机号码">
      </div>
      <div class="bottom">
        <input type="text" v-model="code" placeholder="请输入验证码">
        <a href="javascript:void(0)" @click="getCode">{{msg}}</a>
      </div>
      <a href="javascript:void(0)" class="save" @click="receive">确认领取</a>
    </div>
    <div class="no-count-box" v-show="isCount">
      <img src="/static/images/no-count.png" alt="">
      <p>暂无数据</p>
    </div>
  </div>

</template>

<script>
export default {
  name: 'fiveSteps',
  data () {
    return {
      hUrl:'http://hengtong.yl-mall.cn',
      token:'',
      info:{},// 详情
      tabIndex:0,
      msg: '获取验证码',
      code:'',//获取验证码
      phone:'',//手机号
      courseid:'',// 课程id
      buyuserid:'',//赠送用户id
      isShow:true,
      chapterlist:[],//章节列表
      commentlist:[],//评论列表
      isCount:false
    }
  },
  mounted(){
    if(this.getUrlParamURLys("courseid")){
      this.courseid=this.getUrlParamURLys("courseid");
      this.getchapterlist();
      this.getcomment();
    }
    if(this.getUrlParamURLys("buyuserid")){
      this.buyuserid=this.getUrlParamURLys("buyuserid");
    }
    this.getinfo();

  },
  methods:{
    // tab切换
    tab:function(index){
      this.tabIndex=index;
      if(index==1 && this.chapterlist.length==0){
        this.isCount=true;
      }else if (index==1 && this.chapterlist.length>0){
        this.isCount=false;
      }else if (index==2 && this.chapterlist.length==0){
        this.isCount=true;
      }else if (index==2 && this.chapterlist.length>0){
        this.isCount=false;
      }else if(index==3 && this.commentlist.length==0){
        this.isCount=true;
      }else if(index==3 && this.commentlist.length>0){
        this.isCount=false;
      }else {
        this.isCount=false;
      }
    },
    // 关闭弹窗
    close:function(){
      var _this=this;
      _this.isShow=false;
    },
    // 获取验证码
    getCode:function(){
      var _this=this;
      if(_this.phone==''){
        Yeffect.mAlert("手机号不能为空");
        return false;
      }else if(_this.send==false){
        Yeffect.mAlert("已发送，请耐心等待");
        return false;
      }
      _this.seconds=60;
      _this.call_net("POST", "/api/app/sms/send", {smstype: 5, phone: _this.phone}, function (data) {
        if (data.code === 200) {
          Yeffect.mAlert("发送成功");
          _this.send=false;
          //debugger;
          _this.overTime();
        } else {
          Yeffect.mAlert(data.desc)
        }
      });
    },
    overTime: function () {
      // debugger;
      var self = this;
      if (this.seconds > 1) {
        this.seconds--;
        this.msg = this.seconds + "秒";
        setTimeout(function () {
          self.overTime()
        }, 1000)
      } else {
        this.msg = "获取验证码";
        this.send=true;
      }
    },
    // 领取课程
    receive:function(){
      var _this=this;
      var obj={};
      obj.buyuserid=_this.buyuserid;
      obj.code=_this.code;
      obj.courseid=_this.courseid;
      obj.phone=_this.phone;
      _this.call_net("POST","/api/app/course/receive",obj,function (data) {
        if(data.code===200){
          //debugger;
          Yeffect.mAlert("领取成功");
          _this.token=data.data.token;
          _this.isShow=false;
          _this.getinfo();
        }else if(data.code==-203){
          Yeffect.mAlert(data.desc);
          _this.token=data.data.token;
          _this.isShow=false;
          _this.getinfo();
        }else{
          Yeffect.mAlert(data.desc);
        }
      });
    },
    // 课程详情
    getinfo:function () {
      //debugger;
      var _this=this;
      _this.call_net("POST","/api/app/course/info",{courseid:_this.courseid,token:_this.token},function (data) {
        if(data.code===200){
          _this.info=data.data;
          _this.info.infoImg=_this.hUrl+data.data.infoImg
        }else {
          Yeffect.mAlert(data.desc);
        }
      });
    },
    // 章节列表
    getchapterlist:function () {
      var _this=this;
      var obj={};
      obj.courseid=_this.courseid;
      obj.pageindex=1;
      obj.pagesize=100;
      _this.call_net("POST","/api/app/course/chapterlist",obj,function (data) {
        if(data.code===200){
          var list=data.data;
          if( list.length>0){
            list.forEach(function (el,index) {
              el.fileUrl=_this.hUrl+el.fileUrl;
            })
          }
          _this.chapterlist=list;
        }else {
          Yeffect.mAlert(data.desc);
        }
      });
    },
    // 评论列表
    getcomment:function () {
      var _this=this;
      var obj={};
      obj.courseid=_this.courseid;
      obj.pageindex=1;
      obj.pagesize=100;
      _this.call_net("POST","/api/app/comment/list",obj,function (data) {
        if(data.code===200){
          var list=data.data;
          if( list.length>0){
            list.forEach(function (el,index) {
              el.userImg=_this.hUrl+el.userImg;
            })
          }
          _this.commentlist=list;
        }else {
          Yeffect.mAlert(data.desc);
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .mask{
    background: rgba(0,0,0,0.4);
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    left: 0;
  }
  .mask-con{
    position: absolute;
    left: 50%;
    width: 7rem;
    margin-left: -3.5rem;
    background-color: #fff;
    top:50%;
    margin-top: 20%;
    height: 5rem;
    margin-top: -2.5rem;
    border-radius: 0.1rem;
    padding-top: 0.4rem;
    box-sizing: border-box;
  }
  .mask-con .close{
    position: absolute;
    right: 0.04rem;
    top: -0.18rem;
    width: 0.4rem;

  }
  .mask-con .bottom{
    width: 5.8rem;
    margin: 0 auto;
    height: 0.8rem;
    background-color: #fff;
    margin-top: 0.3rem;
    font-size: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    border: 1px solid #f2f2f2;
  }
  .mask-con .bottom input{
    display: inline-block;
    width: 3.6rem;
    border: none;
    outline: none;
    height: 0.8rem;
    padding-left: 0.28rem;
    color: #999;
    font-size: 0.26rem;
  }
  .mask-con .bottom a{
    float: right;
    width: 1.7rem;
    height: 0.8rem;
    line-height: 0.8rem;
    background-color: #D7B177;
    font-size: 0.26rem;
    text-align: center;
    color: #fff;
  }
  .save{
    display: block;
    margin: 0 auto;
    width: 5.8rem;
    height: 0.8rem;
    line-height: 0.8rem;
    background-color: #D7B177;
    font-size: 0.26rem;
    text-align: center;
    color: #fff;
    border-radius: 0.1rem;
    margin-top: 0.4rem;
  }
  .course-banner{
    width: 100%;
    height: 5rem;
    margin-bottom: 0.2rem;
  }
  .course-banner img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .course-bar{
    overflow: hidden;
    border-bottom: 1px solid #ccc;
  }
  .course-bar a{
    float: left;
    width: 25%;
    text-align: center;
    color: #333333;
    font-size: 0.36rem;
    position: relative;
    padding-bottom: 0.2rem;
  }
  .course-bar a:after{
    content: "";
    position: absolute;
    width: 0.62rem;
    height: 0.05rem;
    background-color: #fff;
    bottom: 0;
    left: 50%;
    margin-left: -0.31rem;
  }
  .course-bar a.active:after{
    background-color: #D7B177;
  }
  .course-con{
    margin-top: 0.3rem;
    padding-bottom: 1.04rem;
  }
  .course-con .course-con-item{
    padding: 0.16rem;
    padding-bottom: 0.3rem;
    border-bottom: 0.2rem solid #F5F6F7;
  }
  .course-con .course-con-item:last-child{
    border-bottom: none;
  }
  .com-title{
    font-size: 0.36rem;
    color: #333333;
    position: relative;
    padding-left: 0.24rem;
    margin-bottom: 0.3rem;
  }
  .com-title:before{
    content: "";
    width: 0.08rem;
    height: 0.34rem;
    background-color: #D7B177;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -0.17rem;
  }
  .course-con .course-con-item .txt{
    padding-left: 0.26rem;
    font-size: 0.28rem;
    color: #333;
    line-height: 0.4rem;
  }
  .download{
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 1.04rem;
    border-top:1px solid #F4F4F4;
    padding: 0.17rem;
    box-sizing: border-box;
    background-color: #fff;
  }
  .download a{
    display: block;
    width: 100%;
    height: 0.7rem;
    background-color: #D7B177;
    color: #fff;
    font-size: 0.3rem;
    text-align: center;
    line-height: 0.7rem;
    border-radius: 0.35rem;
  }
  .chapterlist li{
    border-bottom:1px solid rgba(239,239,239,1);
    padding: 0.28rem;
  }
  .chapterlist li a{
    font-size: 0.3rem;
    color: #333;
  }
  .kejian{
    padding: 0.28rem;
    padding-top: 0;
  }
  .commentList{
    padding: 0.28rem;
  }
  .commentList li{
    padding: 0.3rem 0;
    padding-left: 0.8rem;
    position: relative;
  }
  .commentList li img{
    position: absolute;
    width: 0.7rem;
    height: 0.7rem;
    left: 0;
    top:0.28rem;
  }
  .commentList li .li-rt h1{
    overflow: hidden;
    margin-bottom: 0.2rem;
  }
  .commentList li .li-rt h1 span{
    color: #333333;
    float: left;
    font-weight: normal;
    font-size: 0.26rem;
  }
  .commentList li .li-rt h1 i{
    color: #999999;
    float: right;
    font-size: 0.22rem;
    font-weight: normal;
  }
  .commentList li .li-rt p{
    font-size: 0.24rem;
    color: #666;
    line-height: 0.38rem;
  }
  .commentList li .li-rt{
    padding-bottom: 0.2rem;
    border-bottom: 1px solid #EFEFEF;
  }
  .no-count-box{
    padding-top: 2rem;
  }
  .no-count-box img{
    display: block;
    margin: 0 auto;
    width: 100px;
  }
  .no-count-box p{
    text-align: center;
    margin-top: 0.4rem;
    font-size: 0.24rem;
    color: #C9CACA;
  }
  .kejian img{
    display: block;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/courseShare.vue